import { WfHeader, WfMenuList, WfMenuListItem } from "@WahooFitness/redesignr";
import { postLogOut, postRoute } from "@WahooFitness/wahoo-offline-mfe";
import { t } from "@lingui/macro";
import { useCallback } from "react";
import { ReactRouterLinkWrapper } from "../../MenuList/ReactRouterLinkWrapper";
import { Box } from "@mui/material";

interface HelpSectionProps {
  setupLink: string;
  showSubmitFeedback: boolean;
}

const EXTERNAL_LINKS = {
  termsOfService: "https://wahoosystm.com/TermsOfService",
  privacyPolicy: "https://wahoosystm.com/PrivacyPolicy",
  submitTicket: "https://wahoosystm.com/SubmitATicket",
  submitFeedback: "https://wahoosystm.com/Apollo/reportbug",
};

function HelpSection({ setupLink, showSubmitFeedback }: HelpSectionProps) {
  const goToAttributions = useCallback(() => postRoute("attributions"), []);
  const handleLogOut = useCallback(() => postLogOut(), []);

  return (
    <>
      <WfHeader title={t`Help & Support`} hierarchy="H1" data-testid="helpAndSupportHeader" />
      <WfMenuList>
        <WfMenuListItem
          id="set-up-guides"
          content={t`Set up guides`}
          variant="externalLink"
          href={setupLink}
          data-testid="settings.setUpGuides"
        />
        <WfMenuListItem
          id="terms-of-service"
          content={t`Terms of service`}
          variant="externalLink"
          href={EXTERNAL_LINKS.termsOfService}
          data-testid="settings.termsOfService"
        />
        <WfMenuListItem
          id="privacy-policy"
          content={t`Privacy policy`}
          variant="externalLink"
          href={EXTERNAL_LINKS.privacyPolicy}
          data-testid="settings.privacyPolicy"
        />
        <WfMenuListItem
          id="support"
          content={t`Support`}
          variant="externalLink"
          href={EXTERNAL_LINKS.submitTicket}
          data-testid="settings.support"
        />
        <WfMenuListItem
          id="attributions"
          content={t`Attributions`}
          variant="action"
          action={goToAttributions}
          data-testid="settings.attributions"
        />
      </WfMenuList>
      {showSubmitFeedback && (
        <WfMenuList>
          <WfMenuListItem
            id="submit-feedback"
            content={t`Submit feedback`}
            variant="externalLink"
            href={EXTERNAL_LINKS.submitFeedback}
            data-testid="settings.submitFeedback"
          />
        </WfMenuList>
      )}
      <Box display="flex" flexDirection="column" gap={1} mt={3}>
        <WfMenuList>
          <WfMenuListItem
            id="delete-account"
            content={t`Delete account`}
            variant="internalLink"
            href="/deleteAccount"
            linkComponent={ReactRouterLinkWrapper}
            data-testid="settings.deleteAccount"
            isDestructive
          />
        </WfMenuList>
        <WfMenuList>
          <WfMenuListItem
            id="logout"
            content={t`Log out`}
            variant="action"
            isDestructive
            action={handleLogOut}
            data-testid="settings.logout"
          />
        </WfMenuList>
      </Box>
    </>
  );
}

export default HelpSection;
